import { __rest } from "tslib";
import React, { forwardRef, useRef, useState, } from 'react';
import styled from 'styled-components';
import { useMergeRefs } from 'use-callback-ref';
import { Indicator } from './Indicator';
import { Wrapper } from './Tabs.styled';
import { TabsContext } from './TabsContext';
import { useTabsIndicatorCalculations } from './useTabsIndicatorCalculations';
import { Layout, ORIENTATION } from '../constants';
export const Tabs = styled(
// eslint-disable-next-line react/display-name
forwardRef((_a, ref) => {
    var { activeTabId, ariaLabel, children, layout = Layout.STRETCH, orientation = ORIENTATION.HORIZONTAL, variant = 'solid' } = _a, rest = __rest(_a, ["activeTabId", "ariaLabel", "children", "layout", "orientation", "variant"]);
    const [activeTabRef, setActiveTabRef] = useState(null);
    const wrapperRef = useRef(null);
    const { indicatorPosition, indicatorSize } = useTabsIndicatorCalculations(wrapperRef, activeTabRef, orientation);
    const mergedRef = useMergeRefs([ref, wrapperRef]);
    return (React.createElement(TabsContext.Provider, { value: { activeTabId, orientation, setActiveTabRef, layout, variant } },
        React.createElement(Wrapper, Object.assign({ "aria-label": ariaLabel, layout: layout, orientation: orientation, ref: mergedRef, role: "tablist" }, rest),
            children,
            activeTabId !== undefined && (React.createElement(Indicator, { indicatorPosition: indicatorPosition, indicatorSize: indicatorSize, orientation: orientation })))));
})) ``;
//# sourceMappingURL=Tabs.js.map